import axios from 'axios';
import jwt from 'modules/jwt';
import { hubId, apiUrl, lang } from '../from-hub.js';

const C2_HOMEPAGE_URL = 'api/c2_homepage';

const jwtAxios = baseUrl => jwt(axios.create({
  baseURL: baseUrl,
  headers: { 'X_ORG_ID': hubId, 'Accept-Language': lang },
  withCredentials: true
}), axios);

export const hubApi = jwtAxios(`${apiUrl}/api`);

export default jwtAxios(`${apiUrl}/${C2_HOMEPAGE_URL}`);
